import { MenuPopper } from './MenuPopper';

// TODO: in v9, move styled() from MenuPopper.jsx to here
export var StyledMenuPopper = MenuPopper;